import './slowstogo/style';
import FormStructure from './slowstogo/form_structure';

export default FormStructure;